/**
 * @file: 笑脸
 * icon-xiaolian
 * https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.13&manage_type=myprojects&projectId=721231&keyword=&project_type=&page=
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/03/03      1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
const IconXiaoLian = ({size=14}) => {
        return (
            <img className="iconfont" width={size}
                src={"https://oss.essaone.com/17c73da8-56af-41d6-a0b4-cdcfba8dd9c7.svg"}></img>
        );
}

export default IconXiaoLian;
